import { ColumnConfig } from '@/components/table/Table';
import { formatDate } from '@/utils';
import {
  DEFAULT_STATUS_CLASS,
  RETURNS_INTAKE_STATUS_CLASSES,
  RETURNS_INTAKE_STATUS_LABELS,
} from './statusChip';

export const returnsIntakeHeadersColumns: ColumnConfig[] = [
  {
    label: 'Conductor',
    field: 'driverName',
    render: (value) => value || '-',
  },
  {
    label: 'Estado',
    field: 'status',
    render: (value) => {
      const label = RETURNS_INTAKE_STATUS_LABELS[value] || value || 'N/A';
      const classes =
        RETURNS_INTAKE_STATUS_CLASSES[value] || DEFAULT_STATUS_CLASS;

      return (
        <div className='flex'>
          <span
            className={`px-3 py-1.5 rounded-lg text-sm font-bold ${classes}`}
          >
            {label}
          </span>
        </div>
      );
    },
  },
  {
    label: 'Cerrado por',
    field: 'closedBy',
    render: (value) => value || '-',
  },
  {
    label: 'Fecha Cierre',
    field: 'closedAt',
    sortable: true,
    render: (value) => (value ? formatDate(new Date(value)) : '-'),
  },
  {
    label: 'Fecha Rendición',
    field: 'processedAt',
    sortable: true,
    render: (value) => (value ? formatDate(new Date(value)) : '-'),
  },
];
